import type { ComponentType } from 'react';

// Retry loading a chunk once to avoid chunk-load errors after a deploy.
export const lazyRetry = (componentImport: () => Promise<any>) => {
  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem('retry-lazy-refreshed') ?? 'false',
    );

    return componentImport()
      .then(component => {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
        resolve(component);
      })
      .catch(error => {
        console.error(error);
        if (!hasRefreshed) {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
          return window.location.reload();
        }
        reject(error);
      });
  });
};
